var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignature(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#595959"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M7.99 3.93l1.937 3.218c.056.094.046.206-.03.292l-4.615 5.364c-.068.079-.18.126-.3.126s-.233-.047-.3-.126L.064 7.44c-.075-.086-.086-.198-.03-.292L1.973 3.93",
    transform: "translate(-148 -645) translate(119 635) translate(31 10) rotate(30 2.012 12.862)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8.65c-.551 0-1-.448-1-1 0-.551.449-1 1-1 .552 0 1 .449 1 1 0 .552-.448 1-1 1z",
    transform: "translate(-148 -645) translate(119 635) translate(31 10) rotate(30 2.012 12.862)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M8.473.508v.92c0 .044-.163.08-.364.08H1.854c-.201 0-.364-.036-.364-.08v-.92",
    transform: "translate(-148 -645) translate(119 635) translate(31 10) rotate(30 2.012 12.862)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12.63L5 8.597",
    transform: "translate(-148 -645) translate(119 635) translate(31 10) rotate(30 2.012 12.862)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/signature.9e921468.svg";
export { ForwardRef as ReactComponent };